import React, { useEffect, useState } from "react";
import { AppBar, Toolbar } from "@mui/material";
import { isEmpty, isNil } from "ramda";

import { useScreen, useMenu, useInvites, useUsers } from "hooks";
import UserPresenter from "presenters/UserPresenter";
import { jjLogger } from "utils/logUtils";

import useStyles from "./useStyles";
import MobileHeader from "./components/MobileHeader";
import DesktopHeader from "./components/DesktopHeader";
import Banner from "./components/Banner";

const Header = () => {
  const classes = useStyles();
  const { isDesktop } = useScreen();
  const { loadMenu, menuItems } = useMenu();
  const { currentUser } = useUsers();
  const { loadInvites, invites, invite } = useInvites();

  const [isInvitesAvilable, setIsInvitesAvilable] = useState(false);

  useEffect(() => {
    try {
      if (UserPresenter.isRegistered(currentUser)) {
        loadInvites();
      }
    } catch (error) {
      jjLogger.logError(`Header.js useEffect(loadInvitesWithLoader): ${JSON.stringify(error)}`);
    }
  }, [currentUser]);

  useEffect(() => {
    if ((!isNil(invites) && !isEmpty(invites)) || !isNil(invite)) {
      setIsInvitesAvilable(true);
    } else {
      setIsInvitesAvilable(false);
    }
  }, [invites, invite]);

  useEffect(() => {
    loadMenu();
  }, []);

  return (
    <>
      <AppBar position="sticky" color="neutral">
        <Toolbar disableGutters classes={{ root: classes.toolbar }}>
          {isDesktop ? <Banner /> : null}
          {isDesktop ? (
            <DesktopHeader menuItems={menuItems} isInvitesAvilable={isInvitesAvilable} />
          ) : (
            <MobileHeader menuItems={menuItems} isInvitesAvilable={isInvitesAvilable} />
          )}
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Header;
